<template>
  <div class="concept">
    <div class="concept-header" v-if="office.concept_title">
      <Container>
        <p class="concept-title text-primary text-bold"
          v-html="office.concept_title"
        />
        <p class="concept-sub-title text-primary"
          v-if="office.concept_sub_title"
          v-html="office.concept_sub_title"
        />
      </Container>
    </div>
    <div class="concept-content">
      <Container>
        <p class="concept-body"
          v-html="$domUtils.nl2br(business.concept_body)"
        />
      </Container>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    office: {
      type: Object,
      required: true
    },
    business: {
      type: Object,
      required: true
    }
  }
}
</script>